import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "errorpage",
  class: "w-full h-full"
}
const _hoisted_2 = { class: "flex flex-col h-full justify-center items-center" }
const _hoisted_3 = { class: "mt-10" }

import { onMounted, ref } from "vue";
import {$t} from "@/utilities/i18n/config";
import { useGlobalStore } from "@/stores/GlobalStore";
import { useRoute } from 'vue-router';



export default /*#__PURE__*/_defineComponent({
  __name: 'DisdiError',
  setup(__props) {

const globalStore = useGlobalStore();
const url = ref<string>("");

 
const logout = () => {
    window.location.href = url.value;
    return;
}

onMounted(() => {
  const route = useRoute();
  const returnUrl = route.query.returnUrl;
  const authorityUrl = globalStore.settings.startupConfig?.idsUrl;
  const encodedUrl = encodeURIComponent(returnUrl);
  url.value = authorityUrl + "/sign-out?returnUrl=" + encodedUrl;

  globalStore.resetState();
  globalStore.user = null;
  globalStore.token = "";  
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", null, _toDisplayString(_unref($t)("disdi.error.errorText")), 1),
      _createElementVNode("h3", null, _toDisplayString(_unref($t)("disdi.error.notFount")), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "primary",
          onClick: logout
        }, _toDisplayString(_unref($t)("logout.buttonText")), 1)
      ])
    ])
  ]))
}
}

})